import { observer } from 'mobx-react-lite';
import { QueueStateContext } from '../queues/context/queue-state-context';
import { useIntegratedUnitQueueStore } from './use-integrated-unit-queue-store';

export const UnitQueueStateProvider = observer(function UnitQueueStateProvider(props: {
    children: React.ReactNode;
}): React.ReactElement {
    const { store } = useIntegratedUnitQueueStore();

    return <QueueStateContext.Provider value={store}>{props.children}</QueueStateContext.Provider>;
});
